export const APP_BASE_URL = '';

export const MESSAGE_STATUS = {
  FAILED: 'failed',
  SUCCESS: 'success',
  PROGRESS: 'progress',
};

export const MESSAGE_TYPE = {
  INCOMING: 0,
  OUTGOING: 1,
  ACTIVITY: 2,
  TEMPLATE: 3,
};

export const WOOT_PREFIX = 'chatwoot-widget:';

export const REPORT_ROUTES_NAMES = [
  'account_overview_reports',
  'account_bot_analytics',
  'account_call_analytics',
  'conversation_reports',
  'csat_reports',
  'bot_reports',
  'agent_reports',
  'label_reports',
  'inbox_reports',
  'team_reports',
  'sla_reports',
  'account_live_chat_metrics',
];
